import Adjust from '@adjustcom/adjust-web-sdk';
import AsyncStorage from '~global/storage';
import {
  webAdjustToken,
  envAdjust,
  logLevelAdjust,
} from '~config/adjustConfig';

const AdjustSDK = {
  /**
   * Initialize Adjust SDK (stub for web)
   */
  init() {
    try {
      Adjust.initSdk({
        appToken: webAdjustToken,
        environment: envAdjust,
        logLevel: logLevelAdjust,
      });

      Adjust.waitForWebUUID().then((webUuid) => {
        AsyncStorage.setItem('adjust_web_uuid', webUuid);
      });

      console.debug(
        `🎛️ --- \x1b[35m[LILLA-APPS]\x1b[0m[ADJUST]: SDK initialized --- 🎛️`,
      );
    } catch (err) {
      console.error(
        `🚨 --- \x1b[35m[LILLA-APPS]\x1b[0m[ADJUST]: SDK initialization failed: ${err} --- 🚨`,
      );
    }
  },

  /**
   * Track view landing screen (stub for web)
   */
  trackViewLandingScreen() {
    // No-op for web
  },

  /**
   * Track view application (stub for web)
   */
  trackViewApplication() {
    // No-op for web
  },

  /**
   * Track registration completed (stub for web)
   */
  trackRegistrationCompleted() {
    // No-op for web
  },

  /**
   * Track purchase (stub for web)
   */
  trackPurchase() {
    // No-op for web
  },

  /**
   * Track add to cart (stub for web)
   */
  trackAddToCart() {
    // No-op for web
  },

  /**
   * Track initiate checkout (stub for web)
   */
  trackInitiateCheckout() {
    // No-op for web
  },

  /**
   * Track add payment info (stub for web)
   */
  trackAddPaymentInfo() {
    // No-op for web
  },

  /**
   * Track initiate purchase (stub for web)
   */
  trackInitiatePurchase() {
    // No-op for web
  },

  /**
   * Track view application page home (stub for web)
   */
  trackViewApplicationPageHome() {
    // No-op for web
  },

  /**
   * Track view application page product (stub for web)
   */
  trackViewApplicationPageProduct() {
    // No-op for web
  },

  /**
   * Track view application page category (stub for web)
   */
  trackViewApplicationPageCategory() {
    // No-op for web
  },

  /**
   * Track view application page search (stub for web)
   */
  trackViewApplicationPageSearch() {
    // No-op for web
  },

  /**
   * Track view application page cart (stub for web)
   */
  trackViewApplicationPageCart() {
    // No-op for web
  },

  /**
   * Track view application page checkout (stub for web)
   */
  trackViewApplicationPageCheckout() {
    // No-op for web
  },

  /**
   * Track view application page account (stub for web)
   */
  trackViewApplicationPageAccount() {
    // No-op for web
  },

  /**
   * Track view application page wishlist (stub for web)
   */
  trackViewApplicationPageWishlist() {
    // No-op for web
  },

  /**
   * Track view application page order history (stub for web)
   */
  trackViewApplicationPageOrderHistory() {
    // No-op for web
  },

  /**
   * Track login (stub for web)
   */
  trackLogin() {
    // No-op for web
  },

  /**
   * Track logout (stub for web)
   */
  trackLogout() {
    // No-op for web
  },

  /**
   * Track view content (stub for web)
   */
  trackViewContent() {
    // No-op for web
  },

  /**
   * Track search (stub for web)
   */
  trackSearch() {
    // No-op for web
  },

  /**
   * Track view item list (stub for web)
   */
  trackViewItemList() {
    // No-op for web
  },

  /**
   * Track select content (stub for web)
   */
  trackSelectContent() {
    // No-op for web
  },

  /**
   * Track share (stub for web)
   */
  trackShare() {
    // No-op for web
  },

  /**
   * Track add to wishlist (stub for web)
   */
  trackAddToWishlist() {
    // No-op for web
  },

  /**
   * Track remove from wishlist (stub for web)
   */
  trackRemoveFromWishlist() {
    // No-op for web
  },

  /**
   * Track view item (stub for web)
   */
  trackViewItem() {
    // No-op for web
  },

  /**
   * Track custom event (stub for web)
   */
  trackCustomEvent() {
    // No-op for web
  },

  /**
   * Set user ID (stub for web)
   */
  setUserId() {
    // No-op for web
  },

  /**
   * Set push token (stub for web)
   */
  setPushToken() {
    // No-op for web
  },

  /**
   * Track deep link (stub for web)
   */
  trackDeepLink() {
    // No-op for web
  },

  /**
   * Track attribution (stub for web)
   */
  trackAttribution() {
    // No-op for web
  },

  /**
   * Get attribution (stub for web)
   */
  getAttribution() {
    return null;
  },

  /**
   * Get Adjust device ID (adid) for web
   * @returns {Promise<string|null>}
   */
  async getAdid() {
    try {
      const attribution = await Adjust.waitForAttribution();

      return AsyncStorage.setItem(
        'adjust_device_id',
        attribution?.adid ?? 'unknown',
      );
    } catch (err) {
      console.error(
        `🚨 --- \x1b[35m[LILLA-APPS]\x1b[0m[ADJUST]: Failed to get adid: ${err} --- 🚨`,
      );
      return null;
    }
  },

  /**
   * Reset session (stub for web)
   */
  resetSession() {
    // No-op for web
  },

  /**
   * Enable/disable SDK (stub for web)
   */
  setEnabled() {
    // No-op for web
  },

  /**
   * Check if SDK is enabled (stub for web)
   */
  isEnabled() {
    return false;
  },
};

export default AdjustSDK;
